import {lazy} from '@aboutyou/lazy-imports';

export const CustomPage = lazy(
  () => import('./CustomPage.eager').then(mod => ({default: mod.CustomPage})),
  {
    aboveTheFold: true,
    isSsrAndNeedsHydration: true,
  },
);
